import {
    ColoursObj,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'

export function OrganisationTag() {
    const { selectedOrg } = useBoundStore(
        useShallow((s) => {
            return {
                selectedOrg: s.selectedOrg,
            }
        })
    )

    if (!selectedOrg || !selectedOrg.friendlyName) return null

    return (
        <Box display={'grid'}>
            <Typography
                id="carouselslide-team-name"
                variant="bodySubtext"
                color={getContrastYIQ(ColoursObj.core.secondary)}
                onClick={() => {
                    window.pushPath('/account/changeOrg')
                }}
                style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    background: ColoursObj.core.secondary,
                }}
            >
                {selectedOrg.friendlyName}
            </Typography>
        </Box>
    )
}
